var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.545 3.555a1.52 1.52 0 0 0-2.693.964v10.035H2.52a1.52 1.52 0 0 0 0 3.038H4.85v10.525a1.52 1.52 0 0 0 3.038 0V17.593H15.128l9.428 11.488a1.52 1.52 0 0 0 2.693-.962V17.593h2.225a1.52 1.52 0 0 0 0-3.038H27.26V4.52a1.52 1.52 0 0 0-3.038 0v10.035H16.57l-9.027-11zm11.52 14.038 5.154 6.28v-6.28H19.065zm-6.423-3.038L7.89 8.765v5.79H12.633z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav);
export default __webpack_public_path__ + "static/media/NAV.3346b0c7357a48cf31045179b33d968a.svg";
export { ForwardRef as ReactComponent };